module.exports = __webpack_public_path__ + "img/flag-usa.53a2798e.svg";